

export function msToDuration(ms: number): string {
    const minutes: number = Math.floor(ms / 60000);
    const seconds: number = Math.floor((ms % 60000) / 1000);

    const mPart: string = minutes ? `${minutes}m` : '';
    const sPart: string = seconds ? `${seconds}s` : '';

    return mPart || sPart ? `${mPart}${sPart}` : '0s';
}

export function durationToMs(value: string): number {
    const minutesPattern = /(?:(\d+)m)?/;
    const secondsPattern = /(?:(\d+)s)?/;
    const optionalSpace = /\s*/;
    const pattern = '^' + minutesPattern.source + optionalSpace.source + secondsPattern.source + '$';
    const match = new RegExp(pattern).exec(value.trim());
    if (!match) throw new Error(`Invalid duration: ${value}`);

    const minutes: number = match[1] ? Number(match[1]) : 0;
    const seconds: number = match[2] ? Number(match[2]) : 0;

    return (minutes * 60 + seconds) * 1000;
}
